import React from 'react';
import { Helmet } from 'react-helmet';

/** Public page for a missing or inactive registry. Uses the standard app header. */
export default function Registry_not_found() {
    return (
        <main>
            <Helmet>
                <title>Registry not found | Greatest Gift</title>
                <meta name='robots' content='noindex, nofollow' />
            </Helmet>

            <h2>This page isn't available</h2>
            <p>This can happen when the registry is no longer active.</p>
            <p className='margin_top_24'>
                <a className='green_text bold' href='https://www.greatestgiftapp.com'>
                    Back to Greatest Gift
                </a>
            </p>
        </main>
    );
}
